module.exports = __webpack_public_path__ + "static/media/12584027_10156470523320301_478682946_n_edited.b3523a9a.jpg";